import { courseformsApi } from "api";
import { QUERIES_KEYS } from "queries";
import { useQuery } from "@tanstack/react-query";

export const useAllCourseFormGroups = (isTemplate?: boolean) => {
  const { isLoading, data, refetch } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_ALL_FORM_GROUPS(isTemplate),
    queryFn: () => courseformsApi.getAll(isTemplate),
  });
  return { isLoading, data, refetch };
};

export const useAllCourseFormGroupsOptions = (isTemplate?: boolean) => {
  const { isLoading, data } = useAllCourseFormGroups(isTemplate);

  const options =
    (data?.data ?? []).map((x) => ({
      value: x.courseFormGroupId.toString(),
      label: x.name,
      group: x,
    })) ?? [];

  return { isLoading, options };
};
